import { render, staticRenderFns } from "./co-view-event.vue?vue&type=template&id=2fbf8e30&"
import script from "./co-view-event.vue?vue&type=script&lang=js&"
export * from "./co-view-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports